import type { ClientCapabilities } from "@serendiptv/contracts";

const CANDIDATE_VIDEO_TYPES = [
  "video/mp4; codecs=avc1.42E01E,mp4a.40.2",
  "video/mp4; codecs=avc1.4D401E,mp4a.40.2",
  "video/webm; codecs=vp9,opus",
  "video/webm; codecs=vp8,vorbis"
];

export function detectCapabilities(): ClientCapabilities {
  const video = typeof document === "undefined" ? null : document.createElement("video");
  const videoTypes = video
    ? CANDIDATE_VIDEO_TYPES.filter((type) => {
        const support = video.canPlayType(type);
        return support === "probably" || support === "maybe";
      })
    : [];

  return {
    video_types: videoTypes,
    seek_required: true,
    touch_capable: typeof navigator !== "undefined" && (navigator.maxTouchPoints > 0 || "ontouchstart" in window),
    viewport_width: typeof window !== "undefined" ? window.innerWidth : undefined,
    viewport_height: typeof window !== "undefined" ? window.innerHeight : undefined,
    autoplay_muted_required: undefined
  };
}
